// @core/api/endpoints/calendar/delete_calendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/calendar';

/**
 * Delete calendar
 * Permanently deletes a calendar and all its events, members, and associated data. Requires owner or admin privileges.
 */
export async function DeleteCalendar(
  calendar_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
